export const statusTypes = {
  INIT: 'INIT',
  FETCHING: 'FETCHING',
  RE_FETCHING: 'RE_FETCHING',
  SUCCESS_PAYMENT_METHODS: 'SUCCESS_PAYMENT_METHODS',
  CREATE_SUCCEEDED: 'CREATE_SUCCEEDED',
  START_SUCCEEDED: 'START_SUCCEEDED',
  SUCCESS: 'SUCCESS',
  DONE: 'DONE',
  ERROR: 'ERROR'
};
